<template>
  <dashboard-page
    :aspect-menu-items="aspectMenuItems"
    :custom-action-data="customActionData"
    :errors="errors"
    :meta="meta"
    :model="model"
    :models="models"
    :nav-items="aspectMenuItems"
    :toasts="toasts"
  >
  </dashboard-page>
</template>

<script>
import DashboardPage from '@/structures/default/Pages/Models/Dashboard';

export default {
  components: {
    DashboardPage,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    models: { type: Object, default: () => {} },
    meta: { type: Object, default: () => {} },
    logEntries: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
    customActionData: { type: Object, default: () => {} },
  },
  setup() {
    return {};
  },
};
</script>
